import React from 'react';
import { Badge, Chip } from '@mui/material';

import { UI } from './tokens';

// Pill-shaped alert indicator used in the pipeline-monitoring toolbar (Pipeline Alerts /
// Session Alerts). Owning the shape, weight and hover-lift here keeps the pattern in one
// place instead of repeated local `sx` objects that drift between views; if it gets reused
// beyond this screen it is a candidate to promote to `@zippeditoolsjs`.
const chipSx = {
  height: 36,
  fontSize: 13,
  fontWeight: 600,
  borderRadius: UI.radiusPill,
  cursor: 'pointer',
  '& .MuiChip-icon': { fontSize: 18 },
  transition: 'box-shadow .15s ease',
  '&:hover': { boxShadow: '0 2px 6px rgba(26,36,45,0.18)' },
};

/**
 * A clickable alert pill badged with a count. Renders nothing when `count` is 0/falsy, so
 * call sites don't need their own conditional. `color` drives both the badge and the chip
 * (MUI palette key, e.g. 'error' | 'warning').
 */
export default function AlertIndicatorChip({ count, icon, label, color, onClick }) {
  if (!count) {
    return null;
  }

  return (
    <Badge badgeContent={count} color={color}>
      <Chip
        icon={icon}
        label={label}
        color={color}
        variant="outlined"
        onClick={onClick}
        sx={chipSx}
      />
    </Badge>
  );
}
